import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=8769f548&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Home.vue?vue&type=style&index=0&id=8769f548&lang=sass&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "8769f548",
  "5c91dc78"
  
)

export default component.exports